(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var main = document.querySelector('main.content-for-layout');
  if (!main) return;

  var sections = main.querySelectorAll(':scope > .shopify-section');
  if (!sections.length) return;

  document.documentElement.classList.add('somnia-reveal');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -8% 0px' }
  );

  sections.forEach(function (section, index) {
    if (index === 0) {
      section.classList.add('is-visible');
    } else {
      observer.observe(section);
    }
  });

  window.setTimeout(function () {
    sections.forEach(function (section) {
      section.classList.add('is-visible');
    });
  }, 4000);
})();
